import { z } from 'zod';
import { displayNameField } from '../auth/dto.js';
import type { PublicUserDto } from '../auth/dto.js';
import type { GameSlug, MatchResult, MatchStatus } from '../games.js';
import { avatarIdField } from './avatars.js';

/** Contrats profil & historique (spec 01 §4/§8). Jamais l'email dans le public. */

export const BIO_MAX_LENGTH = 280;

export const UpdateProfileSchema = z
  .object({
    displayName: displayNameField.optional(),
    // Avatar du catalogue uniquement (spec 07 §2.2) — null = retour mascotte.
    avatarId: avatarIdField.nullable().optional(),
    bio: z
      .string()
      .max(BIO_MAX_LENGTH, `Ta bio est un poil trop longue (${BIO_MAX_LENGTH} caractères max) !`)
      .nullable()
      .optional(),
  })
  .strict();
export type UpdateProfileDto = z.infer<typeof UpdateProfileSchema>;

export interface PerGameStats {
  game: GameSlug | string;
  wins: number;
  losses: number;
  draws: number;
  played: number;
}

export interface RecentOpponent {
  displayName: string;
  avatarId: string | null;
  /** ISO 8601 */
  lastPlayedAt: string;
}

export interface ProfileStatsDto {
  totalMatches: number;
  perGame: PerGameStats[];
  recentOpponents: RecentOpponent[];
}

/** Profil privé (GET /api/profile/me) — inclut l'email du propriétaire. */
export interface PrivateProfileDto extends PublicUserDto {
  bio: string | null;
  /** ISO 8601 */
  createdAt: string;
}

/** Profil public — jamais l'email. */
export interface PublicProfileDto {
  displayName: string;
  avatarId: string | null;
  bio: string | null;
  createdAt: string;
  stats: ProfileStatsDto;
}

export interface MatchHistoryItemDto {
  matchId: string;
  game: string;
  status: MatchStatus;
  result: MatchResult | null;
  score: number | null;
  opponents: { displayName: string; avatarId: string | null }[];
  /** ISO 8601 */
  finishedAt: string | null;
}

/** Page d'historique (GET /api/profile/:displayName/history, spec 01 §8 / 08 §3). */
export interface MatchHistoryPageDto {
  items: MatchHistoryItemDto[];
  /** Curseur (finishedAt ISO) de la page suivante — absent = fin du fil. */
  nextCursor?: string;
}
